import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

interface TabContentProps {
  readonly label: string;
  readonly id: string;
  readonly isEditing: boolean;
  readonly editValue: string;
  readonly error: string | null;
  readonly onEdit: (id: string) => void;
  readonly onDelete: (id: string, event: React.MouseEvent) => void;
  readonly onEditChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  readonly onKeyPress: (event: React.KeyboardEvent) => void;
  readonly onStopEditing: () => void;
  readonly canDelete: boolean;
  readonly canEdit: boolean;
}

export function CustomTabContent({
  label,
  id,
  isEditing,
  editValue,
  error,
  onEdit,
  onDelete,
  onEditChange,
  onKeyPress,
  onStopEditing,
  canDelete,
  canEdit,
}: TabContentProps) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      {isEditing ? (
        <ClickAwayListener onClickAway={onStopEditing}>
          <TextField
            value={editValue}
            onChange={onEditChange}
            onKeyDown={onKeyPress}
            variant="standard"
            size="small"
            autoFocus
            error={!!error}
            helperText={error}
            onClick={(e) => e.stopPropagation()}
            sx={{
              width: '100px',
              '& .MuiInput-root': {
                fontSize: '0.875rem',
              },
            }}
          />
        </ClickAwayListener>
      ) : (
        <>
          <div
            role="button"
            tabIndex={0}
            onClick={(e) => {
              if (canEdit && e.detail === 2) {
                onEdit(id);
              }
            }}
            onKeyDown={(e) => {
              if (canEdit && (e.key === 'Enter' || e.key === 'Space')) {
                onEdit(id);
              }
            }}
            style={{
              cursor: 'pointer',
              display: 'inline',
            }}>
            {label}
          </div>
          {canDelete && (
            <span onClick={(e) => e.stopPropagation()} style={{ display: 'inline-flex' }}>
              <IconButton
                size="small"
                onClick={(e) => onDelete(id, e)}
                sx={{
                  ml: 1,
                  opacity: 0.4,
                  padding: '2px',
                  height: '16px',
                  width: '16px',
                  minHeight: '16px',
                  '&:hover': {
                    opacity: 0.7,
                    backgroundColor: 'transparent',
                  },
                }}
                disableRipple>
                <CloseIcon
                  fontSize="small"
                  sx={{
                    fontSize: '16px',
                  }}
                />
              </IconButton>
            </span>
          )}
        </>
      )}
    </Box>
  );
}
